import * as firebase from "firebase/app";

import React, { Component } from "react";

import Footer from "../Footer";
// import Meta from "../../helpers/meta";
// import Nav from "../Nav";
import PromoSlider from "./PromoSlider";
import { Redirect } from "react-router";
import RestaurantList from "./RestaurantList";
import { connect } from "react-redux";
import { getPromoSlides } from "../../../services/promoSlider/actions";
import { withRouter } from "react-router-dom";

// import messaging from "../../../init-fcm";
// import { saveNotificationToken } from "../../../services/notification/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { getUserNotifications } from "../../../services/alert/actions";
import {
  resetInfo,
  resetItems,
  //resetBackup,
} from "../../../services/items/actions";

import { Link } from "react-router-dom";
import { getImageUrl } from '../../../helpers/imageUrl';
// import moment from "moment";
import { AppMode } from "../../../constants";
import { setAppMode, initializeAppMode } from "../../../services/settings/actions";

class Home extends Component {
  static contextTypes = {
    router: () => null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedMode: props.appMode || AppMode.SPRINT,
      prevScrollPos: window.pageYOffset,
      visible: true,
      showSearchOnly: true
    };
  }

  handleToggle = (mode) => {
    // console.log('Previous mode:', this.state.selectedMode);
    // console.log('Toggling mode to:', mode);
    
    if(mode === 'Quick Commerce') {
      this.props.setAppMode(AppMode.SPRINT);
      // console.log('🔄 Switched to SPRINT mode');
    } else {
      this.props.setAppMode(AppMode.RELAY);
      // console.log('🔄 Switched to RELAY mode');
    }
  };

  // Handle scroll events to show/hide toggle
  handleScroll = () => {
    const { prevScrollPos } = this.state;
    const currentScrollPos = window.pageYOffset;
    const visible = prevScrollPos > currentScrollPos || currentScrollPos < 10;
    
    this.setState({
      prevScrollPos: currentScrollPos,
      visible
    });
  };

  async componentDidMount() {
    this.props.resetItems();
    this.props.resetInfo();
    const { appMode } = this.props;
    // console.log('Mobile Home - Initial mode:', appMode);
    this.setState({ selectedMode: appMode });

    // Add scroll event listener
    window.addEventListener('scroll', this.handleScroll);

    if (localStorage.getItem("userSetAddress") !== null) {
      if (localStorage.getItem("showPromoSlider") === "true") {
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        if (this.props.user && this.props.user.data) {
          this.props.getPromoSlides(
            userSetAddress.lat,
            userSetAddress.lng,
            this.props.user.data.auth_token,
            this.props.user.data.id
          );
        }
      }

      if (this.props.user.success) {
        this._notificationSubscription = this.props.getUserNotifications(
          this.props.user.data.id, 
          this.props.user.data.auth_token
        );
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages) {
      if (localStorage.getItem("userPreferedLanguage")) {
        this.props.getSingleLanguageData(
          localStorage.getItem("userPreferedLanguage")
        );
      } else {
        if (nextProps.languages.length) {
          // console.log("Fetching Translation Data...");
          const id = nextProps.languages.filter(
            (lang) => lang.is_default === 1
          )[0].id;
          this.props.getSingleLanguageData(id);
        }
      }
    }
  }

  componentWillUnmount() {
    // Remove scroll event listener
    window.removeEventListener('scroll', this.handleScroll);
    
    // Cancel any pending notifications subscription
    if (this._notificationSubscription) {
      this._notificationSubscription.cancel && this._notificationSubscription.cancel();
    }
  }

  // Add search handler
  handleSearch = () => {
    // Navigate to explore page
    this.props.history.push('/explore');
  };

  render() {
    if (window.innerWidth > 768) {
      return <Redirect to="/" />;
    }

    if (localStorage.getItem("userSetAddress") === null) {
      // this.context.router.history.push("/search-location");
      // console.log("Redirect to search location");
      //return <Redirect to="/search-location" />;
      return <Redirect to="/" />;
    }

    const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
    if (
      Object.keys(userSetAddress).length === 0 &&
      userSetAddress.constructor === Object
    ) {
      //return <Redirect to="/search-location" />;
      return <Redirect to="/" />;
    }

    const { user, promo_slides } = this.props;
    const { selectedMode, visible, prevScrollPos } = this.state;

    // console.log(promo_slides.mainSlides.length);

    return (
      <React.Fragment>
        
        
        <div className="main-content-wrapper">
          <div className="height-100-percent bg-white mb-50">
            <React.Fragment>
              {/* Promo Slider section */}
              {promo_slides &&
                localStorage.getItem("showPromoSlider") === "true" && (
                  <React.Fragment>
                    {promo_slides &&
                      promo_slides.mainSlides &&
                      promo_slides.mainSlides.length > 0 && (
                        <PromoSlider
                          slides={promo_slides.mainSlides}
                          size={promo_slides.mainSlides[0]["promo_slider"]["size"]}
                          isCartPage={false}
                        />
                      )}
                  </React.Fragment>
                )}

              {/* Header section with toggle buttons */}
              {localStorage.getItem("quickCommerceHeader") ? (
                <div style={{ position: "relative", marginBottom: "10px" }}>
                  <div style={{ position: "relative" }}>
                    <div style={{ 
                      position: "relative", 
                      height: "250px",
                      width: "100%",
                      minHeight: "250px",
                      paddingBottom: "60px",
                      overflow: "hidden",
                      backgroundImage: `url(${getImageUrl(`/assets/img/logos/${localStorage.getItem("quickCommerceHeader")}`)})`,
                      backgroundSize: "100% 100%",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      borderBottomLeftRadius: "15px",
                      borderBottomRightRadius: "15px",
                    }} className="storehead-container">
                      {/* Semi-transparent overlay */}
                      <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.4) 100%)",
                        pointerEvents: "none"
                      }} />
                      
                      {/* Deliver To section - moved to top left corner */}
                      {user && user.data && user.data.default_address ? (
                        <div style={{ 
                          position: "absolute",
                          top: "10px", 
                          left: "10px",
                          zIndex: 2,
                          borderRadius: "8px",
                        }} className="deliver-container">
                          <Link to="my-addresses" className="anchor-link">
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div>
                                <p style={{ 
                                  color: "#fff", 
                                  textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
                                  margin: 0,
                                  fontSize: "15px",
                                  lineHeight: 1.4,
                                  fontWeight: 500
                                }}>
                                  <i className="si si-location-pin" style={{ marginRight: "4px" }}></i>
                                  <span style={{ fontWeight: "bold" }}>Deliver to:</span>{" "}
                                  {user.data.default_address.tag !== null ? (
                                    <span style={{ 
                                      fontWeight: 700,
                                      textTransform: "capitalize"
                                    }}>
                                      {user.data.default_address.tag}
                                    </span>
                                  ) : (
                                    <span style={{ fontWeight: 700 }}>Home</span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      ) : null}
                      
                      {/* Toggle View Options */}
                      <div style={{ 
                        position: "absolute",
                        bottom: "10px",
                        left: 0,
                        width: "100%",
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        zIndex: 2,
                        opacity: this.state.prevScrollPos < 50 ? 1 : 0,
                        pointerEvents: this.state.prevScrollPos < 50 ? 'auto' : 'none',
                        transition: 'opacity 0.3s ease'
                      }} className="toggle-container">
                        <div style={{
                          background: 'rgba(255, 255, 255, 0.9)',
                          borderRadius: '30px',
                          display: 'flex',
                          padding: '4px',
                          width: '94%',
                          maxWidth: '400px',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          {/* Active Background Indicator */}
                          <div 
                            style={{
                              position: 'absolute',
                              width: '50%',
                              height: '83%',
                              background: '#FFA500',
                              borderRadius: '25px',
                              top: '8.5%',
                              left: '2.5%',
                              transition: 'left 0.3s ease',
                              zIndex: 1,
                            }}
                          />
                          
                          {/* Quick Commerce Button */}
                          <button
                            onClick={() => this.handleToggle('Quick Commerce')}
                            style={{
                              border: 'none',
                              outline: 'none',
                              background: 'transparent',
                              color: '#fff',
                              borderRadius: '30px',
                              padding: '11px 0',
                              fontWeight: 600,
                              fontSize: '17.5px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              width: '50%',
                              zIndex: 10,
                              position: 'relative',
                              letterSpacing: '0.4px'
                            }}
                          >
                            Sprint
                          </button>
                          
                          {/* ECommerce Button */}
                          <button
                            onClick={() => this.handleToggle('ECommerce')}
                            style={{
                              border: 'none',
                              outline: 'none',
                              background: 'transparent',
                              color: '#333',
                              borderRadius: '30px',
                              padding: '11px 0',
                              fontWeight: 600,
                              fontSize: '17.5px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              width: '50%',
                              zIndex: 10,
                              position: 'relative',
                              letterSpacing: '0.4px'
                            }}
                          >
                            Relay
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="home-page-header">
                  <div className="img-content">
                    <div className="logo-img-container">
                      <img
                        src={`/assets/img/logos/${localStorage.getItem(
                          "storeLogo"
                        )}`}
                        alt={localStorage.getItem("storeLogo")}
                        className="logo-e"
                      />
                    </div>
                    <div className="header-content">
                      <p className="header-data">Elevate Your Sports</p>
                      <p className="header-data" style={{ fontSize: "23px" }}>
                        Order Now!!!
                      </p>
                    </div>
                  </div>

                  {/* Toggle View Options */}
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    margin: '20px 0 10px',
                    position: 'relative',
                  }} className="toggle-container">
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '30px',
                      display: 'flex',
                      padding: '4px',
                      width: '90%',
                      maxWidth: '362px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}>
                      {/* Active Background Indicator */}
                      <div 
                        style={{
                          position: 'absolute',
                          width: '50%',
                          height: '83%',
                          background: '#FFA500',
                          borderRadius: '25px',
                          top: '8.5%',
                          left: '2.5%',
                          transition: 'left 0.3s ease',
                          zIndex: 1,
                        }}
                      />
                      
                      {/* Quick Commerce Button */}
                      <button
                        onClick={() => this.handleToggle('Quick Commerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: '#fff',
                          borderRadius: '30px',
                          padding: '10px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Sprint
                      </button>
                      
                      {/* ECommerce Button */}
                      <button
                        onClick={() => this.handleToggle('ECommerce')}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          color: '#333',
                          borderRadius: '30px',
                          padding: '10px 0',
                          fontWeight: 600,
                          fontSize: '17.5px',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          width: '50%',
                          zIndex: 10,
                          position: 'relative',
                          letterSpacing: '0.4px'
                        }}
                      >
                        Relay
                      </button>
                    </div>
                    
                  </div>
                  
                </div>
              )}

              {/* Sticky Search Bar - Below Toggle Buttons */}
              <div style={{
                position: "-webkit-sticky",
                position: "sticky",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 999,
                background: "#fff"
              }}>
                <div style={{
                  width: "100%",
                  background: "#fff"
                }}>
                  <Link
                    to="/explore"
                    className="anchor-link"
                    style={{ width: "100%", display: "block" }}
                    onClick={this.handleSearch}
                  >
                    <div style={{
                      padding: "8px 15px"
                    }}>
                      <div style={{
                        background: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "12px 15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%"
                      }}>
                        <div>
                          <span style={{ color: "#777", fontSize: "14px" }}>
                            {localStorage.getItem("mockSearchPlaceholder") || "Search..."}
                          </span>
                        </div>
                        <div>
                          <i className="si si-magnifier" style={{ color: "#555" }} />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
             

              {/* Rest of the content */}
              {localStorage.getItem("customHomeMessage") !== "<p><br></p>" &&
                localStorage.getItem("customHomeMessage") !== "null" &&
                (localStorage.getItem("customHomeMessage") !== "" && (
                  <div
                    style={{ position: "relative", background: "#f8f9fa" }}
                    dangerouslySetInnerHTML={{
                      __html: localStorage.getItem("customHomeMessage"),
                    }}
                  />
                ))}
              <RestaurantList user={user} slides={promo_slides.otherSlides} />
              <Footer active_nearme={true} />
            </React.Fragment>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  promo_slides: state.promo_slides.promo_slides,
  user: state.user.user,
  locations: state.locations.locations,
  languages: state.languages.languages,
  appMode: state.settings.appMode,
});

export default withRouter(connect(
  mapStateToProps,
  {
    getPromoSlides,
    getUserNotifications,
    resetInfo,
    resetItems,
    getSingleLanguageData,
    setAppMode,
    initializeAppMode,
  }
)(Home));

